import React from 'react';

import { GenericP, TooltipContainer } from 'commonStyles';
import { ApprovalIcons } from './listingStyles.js';
import { OopTagWrapper, OopTooltipList, OopTooltipBody } from '../../Styles';

import ToolTip from 'common/Tooltip/PortaledTooltip';

import { APPLICATION_CONSTANTS } from 'AppConstants';

const renderTooltipBody = (reasons) => {
	if (reasons.length === 1) {
		return <GenericP fsize='12px' color='#fff' $lHeight='16px'>{reasons[0]}</GenericP>;
	}

	return (
		<OopTooltipList>
			{reasons.map((reason, index) => (
				<li key={`${index}-${reason}`}>
					<GenericP fsize='12px' color='#fff' $lHeight='16px'>{reason}</GenericP>
				</li>
			))}
		</OopTooltipList>
	);
};

const OutOfPolicyTag = ({ reasons = [], statusText = APPLICATION_CONSTANTS.OOP_TXT }) => {
	const validReasons = Array.isArray(reasons) ? reasons.filter(Boolean) : [];
	const hasReasons = validReasons.length > 0;

	return (
		<OopTagWrapper
			$bg='#FFF5F5'
			color='#EB2026'
			fsize='10px'
			f_weight='700'
			transform='uppercase'
			top_P='2'
			bottom_P='2'
			left_P='6'
			right_P='6'
			$lHeight='14px'
			$border='0.4px solid #FFC0C2'>
			{statusText}
			{hasReasons && (
				<TooltipContainer position='relative' valign='middle'>
					<ApprovalIcons icon='info' />
					<ToolTip
						btm_arr
						bg_color='#000'
						color='#fff'
						boxShadow='0 2px 8px rgba(0, 0, 0, 0.15)'
						padding='10px 12px'>
						<OopTooltipBody>
							{renderTooltipBody(validReasons)}
						</OopTooltipBody>
					</ToolTip>
				</TooltipContainer>
			)}
		</OopTagWrapper>
	);
};

export default OutOfPolicyTag;
